import React, { useState } from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';


import LogoutIcon from '@mui/icons-material/Logout';
import { MdAccountCircle } from "react-icons/md";




import { BrowserRouter, Routes, Route,useNavigate,} from 'react-router-dom';
import CustomRoutes from '../Routes/CustomRoutes';
import ListItems from './listItems';
import { style } from '@mui/icons-material';
import { Button, Menu, MenuItem } from '@mui/material';


const drawerWidth = 290;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      backgroundColor: "#3d3d3d",
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const defaultTheme = createTheme();

const Dashboard = () => {
  
  
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const navigate = useNavigate();

  const logoutHandle= () =>
  {
    localStorage.removeItem('token')
    navigate("/");
    localStorage.removeItem('prefrences')
  }

  const getPreferences = (key) => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
};

const [anchorEl, setAnchorEl] = useState(null);

const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
};

const handleClose = () => {
    setAnchorEl(null);
};

const retrievedPreferences = localStorage.getItem('prefrences');

  return (

      <ThemeProvider theme={defaultTheme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar position="absolute" open={open}>
            
            <Toolbar
              sx={{
                pr: '24px',
                
              }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                sx={{
                  marginRight: '36px',
                  ...(open && { display: 'none' }),
                }}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                sx={{ flexGrow: 1 }}
              >
                
              </Typography>
              {/* <IconButton style={{width:"20px",height:"30px"}}color="inherit" onClick={logoutHandle}>
                <LogoutIcon sx={{width: 40,height: 40}}/>
              </IconButton> */}
              <Button variant='contained' onClick={handleClick} color='error' startIcon={<MdAccountCircle/>}>{retrievedPreferences}</Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                 <MenuItem onClick={logoutHandle}>
                    <LogoutIcon  style={{ marginRight: '0.5em' }} />
                    Logout
                </MenuItem>
                
            </Menu>
            </Toolbar>
          </AppBar>
          <Drawer variant="permanent" open={open} >
         
            <Toolbar
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px:[16],
                
              }}
            >
               <Grid style={{color:"white"}}>SADHANA NDT SERVICES LLP </Grid>
              <IconButton sx={{color:"white"}}  onClick={toggleDrawer}>
                  
                <ChevronLeftIcon />
              </IconButton>
            </Toolbar>
            <Divider />
            <List component="nav">
              <ListItems setOpenparent={setOpen} openparent={open} />
              <Divider sx={{ my: 1 }} />
            </List>
          </Drawer>
          <Box
            component="main"
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              flexGrow:1,
              height: '100vh',
              overflow: 'auto',
            }}
          >
            <Toolbar />
            {/* <Container sx={{ mt: 4, mb: 2 }}>
              <Grid container spacing={3}> */}
              <Paper
  sx={{
    p: 5,
    display: 'flex',
    flexDirection: 'column',
    minHeight: "605px",
    minWidth: "1200px",
    mt:2,
    [defaultTheme.breakpoints.down('sm')]: {
      minHeight: "auto",
      minWidth: "auto",
      padding: "20px",
    },
  }}
>
  <CustomRoutes/>
</Paper>

              {/* </Grid>
            </Container> */}
          </Box>
        </Box>
      </ThemeProvider>

  );
}

export default Dashboard;